import { PersonInfoData } from "../../data/personInfoData";

export class PersonInfoModel {
  public Data: PersonInfoData;

  /** Вычислимое ФИО. */
  get FIO(): string {
    return (
      this.Data.Surname +
      " " +
      this.Data.Name +
      (!this.Data.Patronymic || this.Data.Patronymic.trim() === ""
        ? ""
        : " " + this.Data.Patronymic)
    );
  }

  /** Вычислимое ФИ. */
  get FI(): string {
    return this.Data.Surname + " " + this.Data.Name;
  }

  constructor(personInfoData: PersonInfoData | null = null) {
    if (!personInfoData) {
      this.Data = new PersonInfoData();
    } else {
      this.Data = new PersonInfoData(personInfoData);
    }
  }
}
